import { useIntl } from 'react-intl';

import { useLocale } from 'state/intl';
import { ILocalizedMenuEntry } from 'state/unified-menu/types';

const CAL_SUFFIX = 'Cal';

export const useProductCalories = (product: ILocalizedMenuEntry) => {
  const { locale } = useLocale();
  const { formatMessage } = useIntl();

  const calSuffix = formatMessage({ id: CAL_SUFFIX.toLowerCase() }) ?? CAL_SUFFIX;
  const localizedCalories = Math.floor(product.nutrition?.calories?.def ?? 0).toLocaleString(
    locale
  );

  return `${localizedCalories} ${calSuffix}`;
};
